'use client'
import { TurnkeyEVMWalletConnectors } from '@dynamic-labs/embedded-wallet-evm';
import '../_virtual/_tslib.js';
import '@dynamic-labs/utils';
import '@dynamic-labs/wallet-book';
import '@dynamic-labs/ethereum-core';
import 'viem';
import '@dynamic-labs/wallet-connector-core';
import './walletConnect/walletConnect.js';
import { fetchWalletConnectWallets, getWalletConnectConnector } from './walletConnect/fetchWalletConnectWallets.js';
import { UnknownInjected } from './injected/UnknownInjected.js';
import { FallbackEvmConnector } from './injected/FallbackEvmConnector.js';
import { injectedWalletOverrides, fetchInjectedWalletConnector } from './injected/fetchInjectedWalletConnectors.js';
import { Coinbase } from './coinbase/coinbase.js';

const EthereumWalletConnectors = (props) => [
    ...injectedWalletOverrides,
    ...fetchInjectedWalletConnector(props),
    ...fetchWalletConnectWallets(props),
    ...TurnkeyEVMWalletConnectors(props),
    Coinbase,
    UnknownInjected,
    FallbackEvmConnector,
    getWalletConnectConnector(),
];

export { EthereumWalletConnectors };
